import { html } from 'lit';
import { Flag } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-flag')
export class PdsIconFlag extends PdsIcon {
  @state()
  icon = Flag;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
